import { StainList } from "custom-models/frontLoader";

import { LabStainsState, StainsState } from "reducers/frontLoaderReducers";

export const getStainByLabStainId = (
  labStainId: number,
  stains: StainsState,
  labStains: LabStainsState
): StainList | undefined => {
  const labStain = labStains[labStainId];
  if (!labStain) {
    // TODO: Raise warning in Sentry
    return undefined;
  }

  const stain = stains[labStain.stain_id];
  if (!stain) {
    // TODO: Raise warning in Sentry
    return undefined;
  }
  return stain;
};
